export const CLOSE_LANDING = 'CLOSE_LANDING';

export const CHANGE_SEARCH_FIELD = 'CHANGE_SEARCH_FIELD';

export const SEARCH_MOVIE_PENDING = 'SEARCH_MOVIE_PENDING';
export const SEARCH_MOVIE_SUCCESS = 'SEARCH_MOVIE_SUCCESS';
export const SEARCH_MOVIE_FAIL = 'SEARCH_MOVIE_FAIL';

export const ADD_NOMINEES = 'ADD_NOMINEES';
export const REMOVE_NOMINEES = 'REMOVE_NOMINEES';
export const CLOSE_BANNER = 'CLOSE_BANNER'
